import { connect } from 'react-redux';
import LocationSelection from './LocationSelection';
import { getCitiesList, getCountryList, getFacilitiesList, getProvinceStateList } from '../../selectors/bookingLocation';
import { AppStep } from '../../reducers/navigation';
import { tryNavigateTo } from '../../actions/navigation';
import { setUsedBookingLocalStorage } from '../../actions/bookingLocation';
import {
  selectCountry,
  selectLocation,
  selectLocationId,
  selectProvinceState,
  // selectCity,
  stepBack,
  stepForward,
  trySelectCity,
  trySelectFacility,
  fetchLocations,
  trySelectLocation
} from '../../actions/bookingLocation';
import {
  setEmail,
  setEmail2,
  setFirstName,
  setLastName,
  setPhone,
  setCustomerCardNumber,
  setUsedLocalStorage
} from '../../actions/checkout';
import { selectDate } from '../../actions/date';

const mapStateToProps = state => ({
  locations: state.bookingLocation.locationsData,
  savedLocation: state.bookingLocation.selectedLocation,
  step: state.bookingLocation.step,
  selectedCountry: state.bookingLocation.selectedCountry,
  selectedCountryCanadian: state.bookingLocation.selectedCountryCanadian,
  selectedCity: state.bookingLocation.selectedCity,
  selectedCityUnique: state.bookingLocation.selectedCityUnique,
  selectedProvinceState: state.bookingLocation.selectedProvinceState,
  selectedFacility: state.bookingLocation.selectedFacility,
  navigation: state.navigation,
  // Reselect would be nice here
  cityList: getCitiesList(state.bookingLocation),
  countryList: getCountryList(state.bookingLocation),
  provinceStateList: getProvinceStateList(state.bookingLocation),
  facilityList: getFacilitiesList(state.bookingLocation),
  languageObj: state.language.location_selection_js,

  //customer information -> implemented for link from account-control: must store local storage in as state ASAP and delete local storage
  firstName: state.checkout.firstName,
  lastName: state.checkout.lastName,
  email: state.checkout.email,
  email2: state.checkout.email2,
  phone: state.checkout.phone,

  cusNumber: state.checkout.cusNumber,
  provinciaId: state.checkout.provinciaId,
  cantonId: state.checkout.cantonId,
  distritoId: state.checkout.distritoId,
  barrioId: state.checkout.barrioId,
  direccion: state.checkout.direccion,
  tipoIdent: state.checkout.tipoIdent,
  tipoDoc: state.checkout.tipoDoc,
  areaTelefono: state.checkout.areaTelefono,
  numTelefono: state.checkout.numTelefono,
  correo: state.checkout.correo,
  fullName: state.checkout.fullName,

  customerCardNumber: state.checkout.customerCardNumber,
  usedLocalStorage: state.checkout.usedLocalStorage,

  //booking information -> implemented for link from calendar: must store local storage in as state ASAP and delete local storage
  usedBookingLocalStorage: state.bookingLocation.usedBookingLocalStorage,
  selectedTime: state.date.selectedTime
});

const mapDispatchToProps = dispatch => ({
  selectLocation: location => dispatch(selectLocation(location)),
  stepBack: () => dispatch(stepBack()),
  transitionBack: () => dispatch(tryNavigateTo(AppStep.Location)),
  updateCountry: country => {
    dispatch(selectCountry(country));
    dispatch(stepForward());
  },
  updateProvinceState: provinceState => {
    dispatch(selectProvinceState(provinceState));
    dispatch(stepForward());
  },
  updateCity: city => dispatch(trySelectCity(city)),
  updateFacility: facility => dispatch(trySelectFacility(facility)),
  updateLocationId: LocationId => {
    dispatch(selectLocationId(LocationId));
    dispatch(trySelectLocation(LocationId));
  },
  fetchLocations: () => dispatch(fetchLocations(false)),

  //customer information dispatch functions -> implemented for link from account-control: must store local storage in as state ASAP and delete local storage
  setEmail: (email) => dispatch(setEmail(email)),
  setEmail2: (email2) => dispatch(setEmail2(email2)),
  setFirstName: (firstName) => dispatch(setFirstName(firstName)),
  setLastName: (lastName) => dispatch(setLastName(lastName)),
  setPhone: (phone) => dispatch(setPhone(phone)),
  setCustomerCardNumber: (card_number) => dispatch(setCustomerCardNumber(card_number)),
  setUsedLocalStorage: () => dispatch(setUsedLocalStorage()),

  //booking information dispatch functions -> implemented for link from calendar: must store local storage in as state ASAP and delete local storage
  //updateLocationId <- included above
  //updateCity <- included above
  selectDate: date => dispatch(selectDate(date)),
  //possible sometihng with timeslot id.....
  setUsedBookingLocalStorage: () => dispatch(setUsedBookingLocalStorage())
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationSelection);
